export const PAUSED_TOKENS_BY_CHAIN = {
  [1]: ['WETH'],
  // [CHAINS.OPTIMISM.id]: ['WETH'],
  // [CHAINS.BOBA.id]: ['WETH'],
  // [CHAINS.MOONBEAM.id]: ['WETH'],
  // [CHAINS.BASE.id]: ['WETH'],
  // [CHAINS.ARBITRUM.id]: ['WETH'],
  // [CHAINS.FANTOM.id]: [],
  // [CHAINS.DOGE.id]: ['BUSD', 'WETH'],
  // [CHAINS.KLAYTN.id]: ['WETH'],
}
